export const NAME = 'core'
export const UNIT_SELECTION = 'unitSelection'
